import * as clubLocationsApi from '../api/clubLocationsApi';
import { showErrorPopup } from './notification-actions';

export const FETCH_CLUB_LOCATIONS = 'FETCH_CLUB_LOCATIONS';
export const FETCH_CLUB_LOCATIONS_SUCCESS = 'FETCH_CLUB_LOCATIONS_SUCCESS';
export const FETCH_CLUB_LOCATIONS_ERROR = 'FETCH_CLUB_LOCATIONS_ERROR';
export const ADD_CLUB_LOCATION = 'ADD_CLUB_LOCATION';
export const ADD_CLUB_LOCATION_SUCCESS = 'ADD_CLUB_LOCATION_SUCCESS';
export const EDIT_CLUB_LOCATION_SUCCESS = 'EDIT_CLUB_LOCATION_SUCCESS';
export const SELECT_CLUB_LOCATION_SUCCESS = 'SELECT_CLUB_LOCATION_SUCCESS';
export const EDIT_CLUB_FACILITY_SUCCESS = 'EDIT_CLUB_FACILITY_SUCCESS';
export const SELECT_FACILITY_SUCCESS = 'SELECT_FACILITY_SUCCESS';
export const CLEAR_SELECTED_FACILITY = 'CLEAR_SELECTED_FACILITY';
export const SAVE_COURT_TO_FACILITY_SUCCESS = 'SAVE_COURT_TO_FACILITY_SUCCESS';
export const UPDATE_COURT_SUCCESS = 'UPDATE_COURT_SUCCESS';
export const FETCH_CLUB_LOCATION_FACILITIES_SUCCESS = 'FETCH_CLUB_LOCATION_FACILITIES_SUCCESS';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';
export const ARCHIVE_FACILITY_SUCCESS = 'ARCHIVE_FACILITY_SUCCESS;';
export const FETCH_FACILITY_COURTS_SUCCESS = 'FETCH_FACILITY_COURTS_SUCCESS';
export const FETCH_CLUB_LOCATIONS_WITH_FACILITIES = 'FETCH_CLUB_LOCATIONS_WITH_FACILITIES';
export const FETCH_CLUB_LOCATIONS_WITH_FACILITIES_SUCCESS = 'FETCH_CLUB_LOCATIONS_WITH_FACILITIES_SUCCESS';

export const fetchClubLocations = (clubId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_CLUB_LOCATIONS });
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { data } = await clubLocationsApi.getAllClubLocations(mainApi, clubId);

        dispatch({
            type: FETCH_CLUB_LOCATIONS_SUCCESS,
            payload: data.clubLocations,
        });
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error fetching club locations.',
            error: err,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const fetchClubLocationsWithFacilities = (clubId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: FETCH_CLUB_LOCATIONS_WITH_FACILITIES });
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { data } = await clubLocationsApi.getAllClubLocationsWithFacilities(mainApi, clubId);

        dispatch({
            type: FETCH_CLUB_LOCATIONS_WITH_FACILITIES_SUCCESS,
            payload: data,
        });
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error fetching club locations.',
            error: err,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const selectClubLocation = (location) => async (dispatch) => {
    dispatch({ type: SELECT_CLUB_LOCATION_SUCCESS, payload: location });
};

export const addClubLocation = (clubLocation) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status } = await clubLocationsApi.addClubLocation(mainApi, clubLocation);

        if (status === 200) {
            dispatch(fetchClubLocations(clubLocation.clubId));
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error adding club location.',
            error: err,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const fetchLocationFacilities = (locationId, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { data, status } = await clubLocationsApi.getClubFacilities(mainApi, { locationId, clubId });

        if (status === 200) {
            dispatch({
                type: FETCH_CLUB_LOCATION_FACILITIES_SUCCESS,
                payload: {
                    locationId,
                    facilities: data.facilities,
                },
            });
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching facilities for this club location',
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const editClubLocation = (location) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        await clubLocationsApi.updateClubLocation(mainApi, location);

        const newList = await clubLocationsApi.getAllClubLocations(mainApi, location.clubId);
        const { clubDetails } = getState().club;
        const { locationId: clubCurrentLocationId } = clubDetails?.location || {};
        const { location: newPrimaryLocation } = newList?.data?.clubLocations?.find(l => l.locationType === 'primary') || {};
        if (clubCurrentLocationId !== newPrimaryLocation?.locationId) {
            dispatch({
                type: 'CLUBS:GET_CLUB_DETAILS_SUCESS',
                data: {
                    ...clubDetails,
                    location: newPrimaryLocation,
                },
            });
        }

        dispatch({
            type: EDIT_CLUB_LOCATION_SUCCESS,
            payload: {
                newList: newList.data.clubLocations,
                updatedSelected: newList.data.clubLocations.find(({ id }) => id === location.id),
            },
        });

        dispatch({ type: 'SPLASH_HIDE' });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error editing club location.',
            error: err,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const fetchFacilityCourts = (facilityId, locationId, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status, data } = await clubLocationsApi.fetchFacilityCourts(mainApi, { facilityId, locationId, clubId });

        if (status === 200) {
            dispatch({
                type: FETCH_FACILITY_COURTS_SUCCESS,
                payload: {
                    courts: data,
                    facilityId,
                },
            });
        }

        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching facilities for this club location',
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const saveLocationFacility = (facilityPayload) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status } = await clubLocationsApi.addLocationFacility(mainApi, facilityPayload);

        if (status === 200) {
            dispatch(fetchLocationFacilities(facilityPayload.locationId, facilityPayload.clubId));
        } else {
            dispatch({ type: 'SPLASH_HIDE' });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: `Error adding this location facility.`,
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const updateLocationFacility = (facilityPayload, fromFacilityView = false) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status } = await clubLocationsApi.updateLocationFacility(mainApi, facilityPayload);

        if (status === 200) {
            dispatch(fetchLocationFacilities(facilityPayload.locationId, facilityPayload.clubId));
            dispatch(fetchFacilityCourts(facilityPayload.id, facilityPayload.locationId, facilityPayload.clubId));
            if (fromFacilityView) {
                facilityPayload.type = facilityPayload.facilityType;
                dispatch({ type: EDIT_CLUB_FACILITY_SUCCESS, payload: facilityPayload });
            }
        } else {
            dispatch({ type: 'SPLASH_HIDE' });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error updating this location facility.',
            error,
        }));

        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const handleSelectFacility = (facility) => async (dispatch) => {
    // fetch facility courts if not already fetched

    const selectedFacility = {
        ...facility,
        courts: [], // or the response if we get/need it
    };

    dispatch({ type: SELECT_FACILITY_SUCCESS, payload: selectedFacility });
};

export const saveCourtToFacility = (court, facilityId, locationId, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status } = await clubLocationsApi.addFacilityCourt(mainApi, { court, facilityId, locationId, clubId });

        if (status === 200) {
            dispatch(fetchFacilityCourts(facilityId, locationId, clubId));
            dispatch(fetchLocationFacilities(locationId, clubId));
        } else {
            dispatch({ type: 'SPLASH_HIDE' });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error updating this location facility.',
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const editFacilityCourt = (court, facilityId, locationId, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status } = await clubLocationsApi.editFacilityCourt(mainApi, { court, facilityId, locationId, clubId });

        if (status === 200) {
            dispatch(fetchFacilityCourts(facilityId, locationId, clubId));
        } else {
            dispatch({ type: 'SPLASH_HIDE' });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error updating this facility court.',
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const archiveLocation = (locationId, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status } = await clubLocationsApi.deleteClubLocation(mainApi, { clubId, locationId });

        if (status === 200) {
            dispatch({ type: DELETE_LOCATION_SUCCESS, payload: locationId });
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Cannot delete a primary location, please update another location to be set as the primary.',
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const archiveFacility = (facility, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const {
            clubLocationId,
        } = facility;

        const { status } = await clubLocationsApi.archiveClubFacility(mainApi, { locationId: clubLocationId, clubId, facilityId: facility.id });

        if (status === 200) {
            dispatch({
                type: ARCHIVE_FACILITY_SUCCESS,
                payload: {
                    clubLocationId,
                    facilityId: facility.id,
                },
            });
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching facilities for this club location',
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};

export const archiveCourt = (court, facilityId, locationId, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Loading',
            description: 'Please wait',
        });

        const { status } = await clubLocationsApi.archiveFacilityCourt(mainApi, { facilityId, locationId, clubId, courtId: court.id });

        if (status === 200) {
            dispatch(fetchFacilityCourts(facilityId, locationId, clubId));
            dispatch(fetchLocationFacilities(locationId, clubId));
        } else {
            dispatch({ type: 'SPLASH_HIDE' });
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error archiving this court',
            error,
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};
